import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportControleSustentabilidadeUseCase } from "../../../presentation/useCases/read/get_report_controle_sustentabilidade_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportControleSustentabilidadeUseCase
 */

export class GetReportControleSustentabilidadeUseCase implements IGetReportControleSustentabilidadeUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportControleSustentabilidade(
    requiredMimeType: ReportMimeType | null,
    idObra: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportControleSustentabilidade(
      requiredMimeType,
      idObra
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `controle_sustentabilidade_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
